import {
  initBalanceTableOptsSlice,
  initBalanceTableOptsState,
} from 'src/store/shared/balance-table-opts/factory';
import { persistReducer } from 'redux-persist';
import { withResetState } from 'src/store/actions';
import storage from 'src/store/storage';

const initialState = initBalanceTableOptsState({
  viewGroupBy: 'exchange',
  isSmallBalancesVisible: true,
  isDuplicatesVisible: true,
  isInitialBalanceUsed: false,
  isIgnoreOtherTokens: true,
});

const { reducer, actions } = initBalanceTableOptsSlice({
  sliceName: 'tradingBalancesUI',
  initialState,
});

const balanceTableOptsConfig = {
  key: 'trading/balanceTableOpts',
  version: 1,
  storage,
  blacklist: ['viewMode'],
};

export const tradingTableOptsActions = actions;

export default persistReducer(balanceTableOptsConfig, withResetState(reducer, initialState));
